import { render, staticRenderFns } from "./NavigationBarManager.vue?vue&type=template&id=d25aa724&scoped=true&"
import script from "./NavigationBarManager.vue?vue&type=script&lang=js&"
export * from "./NavigationBarManager.vue?vue&type=script&lang=js&"
import style0 from "./NavigationBarManager.vue?vue&type=style&index=0&id=d25aa724&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d25aa724",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemIcon } from 'vuetify/lib/components/VList';
installComponents(component, {VIcon,VList,VListItem,VListItemIcon})
